import { useEffect } from 'react';
import ServicesHero from './components/ServicesHero';
import ServicesDetail from './components/ServicesDetail';
import ServicesCTA from './components/ServicesCTA';

const SERVICES_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services#webpage`,
      url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services`,
      name: 'Our Services | MAX-Sourcing — Global Pharmaceutical Sourcing & Regulatory',
      description:
        'Explore MAX-Sourcing\'s full range of services: strategic pharmaceutical sourcing, regulatory compliance, executive liaison, and logistics & contracts across North America, Europe, China, and India.',
      inLanguage: 'en',
      isPartOf: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
      },
      about: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      },
      dateModified: '2026-04-07',
      translationOfWork: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services#webpage`,
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services`,
        inLanguage: 'fr',
      },
      workTranslation: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services#webpage`,
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services`,
        inLanguage: 'fr',
      },
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services#service`,
      name: 'Global Pharmaceutical Sourcing & Fine Chemicals Services',
      provider: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      },
      serviceType: 'Pharmaceutical Sourcing',
      areaServed: [
        { '@type': 'Country', name: 'Canada' },
        { '@type': 'Country', name: 'United States' },
        { '@type': 'Country', name: 'United Kingdom' },
        { '@type': 'Country', name: 'China' },
        { '@type': 'Country', name: 'India' },
      ],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'MAX-Sourcing Service Catalogue',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Strategic Sourcing',
              description: 'Global pharmaceutical API and fine chemical sourcing with cGMP compliance verification.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Regulatory Compliance',
              description: 'End-to-end regulatory support for pharmaceutical and chemical supply chains.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Executive Liaison',
              description: 'Bilingual executive-level liaison between North American clients and Asian manufacturers.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Logistics & Contracts',
              description: 'Supply chain logistics management and contract negotiation for global chemical procurement.',
            },
          },
        ],
      },
    },
  ],
};

export default function ServicesPage() {
  useEffect(() => {
    document.title = 'Our Services | MAX-Sourcing — Global Pharmaceutical Sourcing & Regulatory';
    const id = 'schema-services';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SERVICES_SCHEMA);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ServicesHero />
      <ServicesDetail />
      <ServicesCTA />
    </div>
  );
}
